import {
  EMPLOYEE_EMPLOYEE_TYPE_FETCHING,
  EMPLOYEE_EMPLOYEE_TYPE_SUCCESS,
  EMPLOYEE_EMPLOYEE_TYPE_FAILED,
} from "../actions/types";

const initialState = {
  result: null,
  isFetching: false,
  isError: false,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case EMPLOYEE_EMPLOYEE_TYPE_FETCHING:
      return { ...state, result: null, isFetching: true, isError: false };
    case EMPLOYEE_EMPLOYEE_TYPE_FAILED:
      return { ...state, result: null, isFetching: false, isError: true };
    case EMPLOYEE_EMPLOYEE_TYPE_SUCCESS:
      return { ...state, result: payload, isFetching: false, isError: false };
    default:
      return state;
  }
}
